var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('MessageInputField',{on:{"change":_vm.submitMessage}}),_vm._m(0)],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',{staticClass:"text-xs mt-2"},[_c('a',{attrs:{"href":"https://devhints.io/markdown","target":"_blank"}},[_vm._v("Markdown")]),_vm._v(" supported 😉 ")])
}]

export { render, staticRenderFns }